import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useMediaQuery } from 'react-responsive';
import 'bootstrap/dist/css/bootstrap.min.css';
import carosal1 from "../assets/carosalimage1.png";
import carosal2 from "../assets/carosalimage2.png";
import carosal3 from "../assets/carosalimage3.png";
import carosal4 from "../assets/carosalimage4.png"; 
import carosal5 from "../assets/carosalimage5.png";  

const data = [
  // {
  //   image:carosal1,
  //   title: 'Img1',
  // },
  {
    image: carosal2,
    title: 'Img2',
  },
  {
    image: carosal3,
    title: 'Img3',
  },
  {
    image: carosal4,
    title: 'Img4',
  },
  {
    image: carosal5,
    title: 'Img5',
  }
];

const Custumcarousal = () => {
  const isPic = useMediaQuery({ query: '(max-width: 768px)' });

  
  let settings = {
    dots: false, 
    arrows: false, 
    infinite: true,
    speed: 1000,
    slidesToShow: isPic ? 1 : 3, 
    slidesToScroll: isPic ? 1 : 3, 
    autoplay: true, 
    autoplaySpeed: 3000, 
  };

  return (
    <div className="bg-white pt-5">
      <div className="container">
        <Slider {...settings}>
          {data.map((item, index) => {
            return (
              <div key={index} className="bg-white mb-5 rounded shadow">
                <div className="d-flex justify-content-center">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="img-fluid w-100 h-100   object-fit-cover"
                  />
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  )
}

export default Custumcarousal